export enum KnmLoadingFlagsEnum {
  CHECKLISTS = 'CHECKLISTS',
  FNS_LOOKUP_BY_OGRN = 'FNS_LOOKUP_BY_OGRN',
  FNS_LOOKUP_BY_INN = 'FNS_LOOKUP_BY_INN',
  KNM_LINK = 'KNM_LINK',
  KNM_LINKS = 'KNM_LINKS',
  REGISTRY_FNS_MATCH_DATA = 'REGISTRY_FNS_MATCH_DATA',
  REQUIREMENTS = 'REQUIREMENTS',
}
